import DOMPurify from "dompurify";

/**
 * @param {string} dirty - Untrusted HTML string.
 * @returns {string} Sanitized HTML safe to inject into the DOM.
 */
export const sanitizeHtml = (dirty) => DOMPurify.sanitize(dirty ?? "");

/**
 * Turns raw newlines into <br /> in an assistant answer, but only when it has no <br /> already.
 *
 * Answers saved before the chat bubble stopped honouring raw newlines still break with "\n" alone, and
 * the server applies the same rule when it composes an answer. Converting when <br /> is already
 * present would turn the newlines around those tags into extra breaks. Shared by the chat and the usage
 * dashboard's answer view, so the two cannot drift on that edge case.
 *
 * @param {string} html - An answer as the assistant returned it.
 * @returns {string} The answer with line breaks as markup.
 */
export const withLineBreaks = (html) =>
  typeof html === "string" && html.indexOf("\n") >= 0 && !/<br/i.test(html)
    ? html.replace(/\r\n|\r|\n/g, "<br />")
    : html;

export default sanitizeHtml;
